var React = require('react');

function KeyboardArrowUp (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"keyboard_arrow_up"),React.createElement("path",{"d":"M7.406 15.422l-1.406-1.406 6-6 6 6-1.406 1.406-4.594-4.594z","key":1})]);
}

KeyboardArrowUp.defaultProps = {"version":"1.1","width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = KeyboardArrowUp;

KeyboardArrowUp.default = KeyboardArrowUp;
